"use client";
import dynamic from "next/dynamic";

const LostFoundForm = dynamic(
  () => import("./components/LostFoundForm"),
  { ssr: false },
);

export default function LostAndFoundPage() {
  return <LostFoundForm />;
}
